import SectionCard, {
  SectionCardGroup
} from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import UpgradeCard from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeCard";
import { UpgradeInfoCard } from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoCard";
import { enumFeaturesList } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { DynamicTextProps } from "@theorgchartdev/storybook/dist/components/Text/DynamicText";

const UpgradeUIProfiles = () => {
  const upgradeUIProfilesDynamicText: DynamicTextProps = {
    template: appstr("ui profiles upgrade template"),
    formatConfig: { bold1: { type: "bold" } },
    replaceDict: { bold1: appstr("certain UI elements") }
  };

  return (
    <SectionCardGroup>
      <SectionCard
        title={appstr("UI profiles")}
        customCardStyle={{ background: "var(--bg-brand-secondary)" }}
      >
        <div className="ocn-upgrade-card-text">
          <UpgradeCard iconName={"user-pen"} featureKey={enumFeaturesList.uiProfiles}>
            <UpgradeInfoCard.Body dynamic={upgradeUIProfilesDynamicText}>
              {appstr("ui profiles upgrade message")}
            </UpgradeInfoCard.Body>
          </UpgradeCard>
        </div>
      </SectionCard>
    </SectionCardGroup>
  );
};

export default UpgradeUIProfiles;
